import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink, Shield, Heart, Users, Scale, AlertTriangle } from "lucide-react";

const resources = [
  {
    title: "Worker Rights & Safety Basics",
    description:
      "Plain-language information about your rights, staying safe, and knowing what to expect.",
    icon: Shield,
    link: "#",
  },
  {
    title: "Health & Care Resources",
    description:
      "Access to health information, testing, and care resources for adult industry workers.",
    icon: Heart,
    link: "#",
  },
  {
    title: "Privacy Basics",
    description:
      "Tips for protecting your privacy online and off, including digital security basics.",
    icon: Users,
    link: "#",
  },
  {
    title: "Burnout & Stress Support",
    description:
      "Resources for managing stress, burnout, and mental health in the adult industry.",
    icon: Heart,
    link: "#",
  },
  {
    title: "Legal Information",
    description:
      "Basic legal information relevant to adult industry workers. Not legal advice.",
    icon: Scale,
    link: "#",
  },
  {
    title: "Policy Updates (SWC)",
    description:
      "Updates on policy changes that affect worker autonomy and safety.",
    icon: AlertTriangle,
    link: "#",
  },
];

export default function Resources() {
  return (
    <div className="bg-[color:var(--pws-off)] min-h-[calc(100vh-80px)] py-12 md:py-16">
      <div className="container-pws">
        <div className="max-w-5xl mx-auto">
          <h1
            className="font-['Space_Grotesk'] text-3xl sm:text-4xl font-semibold text-[color:var(--pws-charcoal)] tracking-tight"
            data-testid="resources-title"
          >
            Resources
          </h1>
          <p className="mt-3 text-[color:var(--pws-stone)] max-w-2xl">
            Optional resources from Safe Work Coalition. Take what you need, leave
            what you don't.
          </p>

          <div
            className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3"
            data-testid="resources-grid"
          >
            {resources.map((resource, index) => (
              <Card
                key={index}
                className="bg-white border-[color:var(--pws-line)] card-hover"
                data-testid={`resource-card-${index}`}
              >
                <CardHeader className="pb-3">
                  <div className="flex items-start gap-3">
                    <div className="p-2 bg-[color:var(--pws-cream)] rounded-lg">
                      <resource.icon className="h-5 w-5 text-[color:var(--pws-plum)]" />
                    </div>
                    <CardTitle className="text-lg font-medium text-[color:var(--pws-charcoal)]">
                      {resource.title}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-[color:var(--pws-stone)] mb-4">
                    {resource.description}
                  </p>
                  <Button
                    variant="outline"
                    size="sm"
                    className="w-full border-[color:var(--pws-line)] text-[color:var(--pws-plum)] hover:bg-[color:var(--pws-cream)]"
                    disabled
                  >
                    Coming Soon
                    <ExternalLink className="ml-2 h-3 w-3" />
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Disclaimer */}
          <div
            className="mt-12 p-4 bg-[color:var(--pws-cream)] rounded-lg text-center"
            data-testid="resources-disclaimer"
          >
            <p className="text-sm text-[color:var(--pws-stone)]">
              <strong>Disclaimer:</strong> This is not legal advice or medical advice.
              If you're in immediate danger, contact local emergency services.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
